import { call, put, takeEvery } from "redux-saga/effects";
import {
    getProcessing,
    addNewProcessing,
    updateProcessing,
    deleteProcessing,
    deleteMany,
} from "../../api/backend_helper";

import {
    getDataAllSuccess,
    getDataAllFail,
    addProcessing,
    addProcessingFail,
    addProcessingSuccess,
    updateProcessing as updateProcessingAction,
    updateProcessingFail,
    updateProcessingSuccess,
    deleteProcessing as deleteProcessingAction,
    deleteProcessingFail,
    deleteProcessingSuccess,
    deleteManyRequest,
    deleteManyFail,
    deleteManySuccess,
} from "./slice";

function* getProcessingData(action) {
    try {
        const query = action.payload;
        const data = yield call(getProcessing, query);
        yield put(getDataAllSuccess(data));
    } catch (error) {
        yield put(getDataAllFail(error.message));
    }
}

function* createProcessingSaga(action) {
    try {
        const data = yield call(addNewProcessing, action.payload.data);
        yield put(addProcessingSuccess(data));
    } catch (error) {
        yield put(addProcessingFail(error));
    }
}

function* modifyProcessing(action) {
    try {
        const data = yield call(
            updateProcessing,
            action.payload.data.id,
            action.payload.data
        );
        yield put(updateProcessingSuccess(data));
    } catch (error) {
        yield put(updateProcessingFail(error.message));
    }
}

function* removeProcessing(action) {
    try {
        yield call(deleteProcessing, action.payload.id);
        yield put(deleteProcessingSuccess(action.payload.id));
    } catch (error) {
        yield put(deleteProcessingFail(error.message));
    }
}

function* deleteManySaga(action) {
    try {
        yield call(deleteMany, action.payload);
        yield put(deleteManySuccess(action.payload));
    } catch (error) {
        yield put(deleteManyFail(error.message));
    }
}

function* ProcessingsSaga() {
    yield takeEvery("processing/getDataAll", getProcessingData);
    yield takeEvery(addProcessing.type, createProcessingSaga);
    yield takeEvery(updateProcessingAction.type, modifyProcessing);
    yield takeEvery(deleteProcessingAction.type, removeProcessing);
    yield takeEvery(deleteManyRequest.type, deleteManySaga);
}

export default ProcessingsSaga;
